import { render, staticRenderFns } from "./WorkPartner.vue?vue&type=template&id=58d74616&"
import script from "./WorkPartner.vue?vue&type=script&lang=js&"
export * from "./WorkPartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports